// https://stackoverflow.com/questions/9847580/how-to-detect-safari-chrome-ie-firefox-and-opera-browser
real.browser = (function() {
    'use strict';

    var
        isSafari = false,
        isChrome = false,
        isFirefox = false,
        isEdge = false,
        isIE = false,
        isIE11 = false,

        isMac = false,
        isWindows = false,
        isiOS = false
    ;

    // Checking if the browser supports navigator.userAgentData
    if (navigator.userAgentData) {
        // Use new hints
        const userAgentData = navigator.userAgentData;
        userAgentData.brands.filter(function(item) {
            switch (item.brand) {
                case 'Apple Safari':
                    isSafari = true;
                    break;
                case 'Google Chrome':
                    isChrome = true;
                    break;
                case 'Mozilla Firefox':
                    isFirefox = true;
                    break;
                case 'Microsoft Edge':
                    isEdge = true;
                    break;
            }
        });

        isMac = userAgentData.platform.includes('Mac');
        isWindows = userAgentData.platform.includes('Windows');
        isiOS = userAgentData.platform.includes('iOS');
    } else {
        // Fall back to user-agent string parsing
        isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
        isMac     = navigator.platform.indexOf('Mac') > -1;
        isiOS     = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
        isEdge      = navigator.userAgent.indexOf('Edge') > -1;
        isSafari = /constructor/i.test(window.HTMLElement) ||
              (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] ||
              (typeof safari !== 'undefined' && safari.pushNotification))
        isChrome = !!window.chrome && !!window.chrome.webstore;
        isIE = /Trident\/|MSIE/.test(navigator.userAgent);
        isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
    }

    const supportWebP = () => {
        const elem = document.createElement('canvas');
        if (!!(elem.getContext && elem.getContext('2d'))) {
            return elem.toDataURL('image/webp').indexOf('data:image/webp') === 0;
        }
        return false;
    };

    return {

        isSafari  : isSafari,

        isChrome  : isChrome,

        isFirefox : isFirefox,

        isWebkit  : isSafari || isChrome,

        isiOS     : isiOS,

        isMac     : isMac,

        isIE      : isIE,

        isIE11    : isIE11,

        isEdge      : isEdge,

        isWindows : isWindows,

        supportWebP : supportWebP,

        getFriendlyName : function() {
            const getBrowserVendor = function() {
                if (isFirefox) {
                    return 'Firefox';
                }
                if (isEdge) {
                    return 'Edge';
                }
                if (isChrome) {
                    return 'Chrome';
                }
                if (isSafari) {
                    return 'Safari';
                }
                if (isIE || isIE11) {
                    return 'MSIE';
                }

                return null;
            }

            const getBrowserVersion = function(browserVendor) {
                let browserVersion = null;
                const userAgent = navigator.userAgent;

                // Detect safari browser version by using the agent string if it contains the version number
                if (browserVendor === 'Safari' && /Version\//.test(userAgent)) {
                    browserVersion = parseFloat(userAgent.match(/Version\/(\d+(\.\d+)?)/)[1]);
                } else {
                    const regex = new RegExp(browserVendor +'\/([0-9\\.]+)');
                    const match = userAgent.match(regex);
                    if (match !== null && match.length > 1) {
                        browserVersion = parseFloat(match[1]);
                    }
                }
                return browserVersion;
            };

            const browserVendor = getBrowserVendor();
            if (browserVendor === null) {
                return navigator.userAgent;
            }

            const browserVersion = getBrowserVersion(browserVendor);
            if (browserVersion === null) {
                return navigator.userAgent;
            }

            return browserVendor + ' ' + browserVersion.toFixed(1);
        }

    };

})();
